// extracted by mini-css-extract-plugin
export var container = "_mc-0";
export var segment = "_mc-2";
export var segmentActive = "_mc-3";
export var track = "_mc-1";